import Run from './Run'

const Runs = ({ runs, onSelect }) => {
  
    return (
        <div className='runs'>
        {runs.map((run) =>(
            <Run key={run.id} run={run} onSelect={onSelect} />
        ))}   
        </div>
    )
}

export default Runs
